<template>
  <!-- TODO: remove after new similar jobs implementation is complete -->
  <v-menu
    open-on-hover
    :close-on-content-click="true"
    min-width="500"
    max-width="600"
  >
    <template #activator="{ props }">
      <div
        v-bind="props"
        @mouseenter="onMouseEnter"
      >
        Similar Jobs
      </div>
    </template>

    <v-list>
      <!-- Loading State -->
      <v-list-item v-if="loading">
        <template #prepend>
          <v-progress-circular
            indeterminate
            size="20"
            width="2"
            color="primary"
          />
        </template>
        <v-list-item-title>Loading Similar Jobs</v-list-item-title>
      </v-list-item>

      <!-- Error State -->
      <v-list-item v-else-if="error">
        <v-list-item-title>Unexpected error</v-list-item-title>
      </v-list-item>

      <!-- Empty State -->
      <v-list-item v-else-if="Array.isArray(similarJobs) && similarJobs.length === 0">
        <v-list-item-title>No Similar Jobs Found</v-list-item-title>
      </v-list-item>

      <!-- Similar Jobs List -->
      <template v-else>
        <template
          v-for="(similarJob, index) in similarJobs"
          :key="similarJob.id"
        >
          <v-divider
            v-if="similarJob.isFirstTapwageJob && index > 0"
            class="opacity-100"
          />

          <v-list-item
            @click="handleSimilarJobClick(similarJob)"
            class="similar-job-item pa-3"
          >
            <v-list-item-title class="text-wrap text-button-1">
              {{ similarJob.title }}
            </v-list-item-title>

            <v-list-item-subtitle class="d-flex justify-space-between mt-1 text-button-2">
              <span>{{ similarJob.company }}</span>
              <span v-if="similarJob.status">{{ similarJob.status }}</span>
            </v-list-item-subtitle>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { recruitGetSimilarJobsOld } from '@/api/recruit';
import { mapActions, mapState } from 'pinia';
import { useEditor } from '@/stores/editor/editor';

export default {
  name: 'SimilarJobs',
  props: {
    jobId: { type: [Number, String], default: null },
  },
  emits: ['tracking-event'],
  data() {
    return {
      error: null,
      loading: null,
    };
  },
  computed: {
    ...mapState(useEditor, [
      'similarJobs', 'company', 'title', 'location', 'score', 'wordCount', 'revisionId', 'documentType',
    ]),
  },
  watch: {
    jobId: {
      immediate: true,
      handler(jobId) {
        if (jobId) this.loadSimilarJobs(jobId);
      },
    },
  },
  methods: {
    ...mapActions(useEditor, ['setSimilarJobs']),
    async loadSimilarJobs(jobId) {
      this.loading = true;
      try {
        const { similarJobs } = await recruitGetSimilarJobsOld({
          jobId,
        });
        this.setSimilarJobs(similarJobs);

        const firstTapwageJob = this.similarJobs.find((job) => job.status === null) || {};
        firstTapwageJob.isFirstTapwageJob = true;
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    async handleSimilarJobClick(similarJob) {
      const {
        // eslint-disable-next-line camelcase
        id, tapwage_id, title, company,
      } = similarJob;

      this.$emit('tracking-event', {
        action: 'clickSimilarJob',
        args: {
          job: {
            jobId: this.jobId,
            company: this.company,
            title: this.title,
            location: this.location,
            score: this.score,
            wordCount: this.wordCount,
            revisionId: this.revisionId,
            documentType: this.documentType,
          },
          props: { id, title, company },
        },
      });

      await this.$router.push({
        name: 'editor-view',
        params: { id: this.jobId },
        query: {
          ...this.$route.query,
          similarJobs: Number(id) || Number(tapwage_id),
        },
      });
    },

    onMouseEnter() {
      if (!this.jobId) {
        return;
      }

      this.$emit('tracking-event', {
        action: 'viewSimilarJobs',
        args: { job: { jobId: this.jobId } },
      });
    },
  },
};
</script>
